import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-white text-black py-8 mt-6">
            <div className="container mx-auto px-4 flex flex-wrap justify-between items-center">
                {/* Logo Section */}
                <div className="w-full md:w-auto mb-4 md:mb-0 text-center md:text-left">
                    <img
                        src="https://aospea.org/aosp-web-logo.png"
                        alt="AOSP Logo"
                        className="h-12 mx-auto md:mx-0 mb-2"
                    />
                    <p className="text-black text-sm">&copy; {new Date().getFullYear()} AOSP. All rights reserved.</p>
                </div>

                {/* Navigation Links */}
                <div className="w-full md:w-auto flex flex-wrap justify-center md:justify-end space-x-4 text-sm mb-4 md:mb-0">
                    <a href="/privacy" className="hover:underline hover:text-blue-400 transition">Privacy Policy</a>
                    <a href="/terms" className="hover:underline hover:text-blue-400 transition">Terms of Service</a>
                    <a href="/contact" className="hover:underline hover:text-blue-400 transition">Contact Us</a>
                </div>

                {/* Social Media Links */}
                <div className="w-full md:w-auto flex justify-center md:justify-end space-x-4">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-6 h-6">
                            <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.406.593 24 1.325 24h11.495v-9.294H9.847v-3.622h2.973V8.413c0-2.945 1.797-4.554 4.423-4.554 1.256 0 2.336.093 2.649.135v3.07h-1.818c-1.43 0-1.707.679-1.707 1.675v2.192h3.414l-.445 3.622h-2.969V24h5.813c.732 0 1.325-.593 1.325-1.324V1.325C24 .593 23.407 0 22.675 0z" />
                        </svg>
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-6 h-6">
                            <path d="M24 4.557a9.93 9.93 0 0 1-2.828.775 4.933 4.933 0 0 0 2.165-2.723 9.864 9.864 0 0 1-3.127 1.195 4.916 4.916 0 0 0-8.384 4.482A13.94 13.94 0 0 1 1.671 3.149 4.917 4.917 0 0 0 3.148 9.72a4.902 4.902 0 0 1-2.228-.616v.062a4.917 4.917 0 0 0 3.946 4.827 4.936 4.936 0 0 1-2.224.085 4.919 4.919 0 0 0 4.6 3.417A9.867 9.867 0 0 1 0 19.54a13.94 13.94 0 0 0 7.548 2.209c9.142 0 14.307-7.721 13.995-14.646A9.935 9.935 0 0 0 24 4.557z" />
                        </svg>
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-6 h-6">
                            <path d="M22.23 0H1.77C.79 0 0 .774 0 1.727v20.545C0 23.226.79 24 1.77 24h20.46c.98 0 1.77-.774 1.77-1.727V1.727C24 .774 23.21 0 22.23 0zM7.06 20.452H3.644V9.031H7.06v11.421zM5.35 7.744a1.995 1.995 0 1 1 0-3.99 1.995 1.995 0 0 1 0 3.99zM20.452 20.452h-3.415v-5.593c0-1.336-.024-3.056-1.864-3.056-1.865 0-2.15 1.457-2.15 2.962v5.687H9.608V9.031h3.28v1.556h.046c.457-.866 1.576-1.778 3.247-1.778 3.475 0 4.117 2.286 4.117 5.256v6.387z" />
                        </svg>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
